<template>
    <footer id="footer">
        <div id="listas-footer">
            <div class="lado-footer">
                <a href="https://www.instagram.com/j.line_limpeza_higienizacao/" class="conteudo-lista-footer">Instagram: <span class="fino">@j.line_limpeza_higienizacao</span></a>
                <a href="" class="conteudo-lista-footer">FaceBook: <span class="fino">J.Line Limpeza Higienização</span></a>
                <a href="" class="conteudo-lista-footer">Telefone: <span class="fino">+55 (35) 99901-3609</span></a>
            </div>

            <div class="lado-footer">
                <a href="https://api.whatsapp.com/send/?phone=5535999013609&text=Ol%C3%A1%2C+vim+do+cat%C3%A1logo+e+gostaria+de+solicitar+um+or%C3%A7amento+para+o+servi%C3%A7o+de+higieniza%C3%A7%C3%A3o+de+colch%C3%B5es&type=phone_number&app_absent=0" class="conteudo-lista-footer">WhatsApp: <span class="fino">+55 (35) 99901-3609</span></a>
                <a href="" class="conteudo-lista-footer">Endereço: <span class="fino">Minas Gerais</span></a>
            </div>
        </div>

        <p id="final-footer">
            Copyright © {{ currentYear }} - J.Line Limpeza Higienizacao. Todos os direitos reservados.
        </p>
    </footer>
</template>

<script>
export default{
    name: 'FooterLandingPage',
    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
}
}
</script>

<style scoped>
#footer{
    height: 60vh;
    width: 100%;
    background-color: var(--cor-tema);
    display: flex;
    flex-direction: column;
}

#listas-footer{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 36px;
    padding: 36px 22px;
    box-sizing: border-box;
}

.lado-footer{
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.conteudo-lista-footer{
    font-size: 14px;
    color: #ffffff;
    text-decoration: none;
    cursor: pointer;
}

.fino{
    font-weight: 300;
}

#final-footer{
    height: 70px;
    width: 100%;
    background-color: #ffffff;
    margin-top: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    color: var(--cor-tema);
}

@media (min-width: 768px) and (max-width: 1200px){
    #footer{
        height: auto;
    }

    #listas-footer{
        padding: 42px 24px;
        grid-template-columns: 1fr;
        gap: 22px;
        padding-bottom: 120px;
    }
}

@media (max-width: 600px) {
    #footer{
        height: auto;
    }

    #listas-footer{
        padding: 42px 24px;
        grid-template-columns: 1fr;
        gap: 22px;
        padding-bottom: 150px;
    }

    .lado-footer{
        gap: 22px;
    }

    #final-footer{
        padding: 0 24px;
        box-sizing: border-box;
        text-align: center;
    }

    .fino{
        font-size: 13px;
    }
}
</style>